import { render, staticRenderFns } from "./ProductStatic.vue?vue&type=template&id=6fc258cb&scoped=true&"
import script from "./ProductStatic.vue?vue&type=script&lang=js&"
export * from "./ProductStatic.vue?vue&type=script&lang=js&"
import style0 from "./ProductStatic.vue?vue&type=style&index=0&id=6fc258cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc258cb",
  null
  
)

export default component.exports